import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MdInfoOutline } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import ContactService from '../../services/contact.service';
import DetailsViewer from '../../components/DetailsForm/DetailsViewer';
import { toast } from '../../toasts';

function ContactInfo() {
	const params = useParams();
	const { id } = params;
	const [contact, setContact] = useState({});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const result = await ContactService.getDetails(id);
				setContact(result.data);
			} catch (error) {
				toast.error('No se pudo obtener el contacto');
			}
		};
		fetchData();
	}, [id]);

	const contactFields = [
		{
			label: 'Nombre',
			key: 'name',
			type: 'text',
			value: contact.name || '',
			cols: 6,
		},
		{
			label: 'Email',
			key: 'email',
			type: 'text',
			value: contact.email || '',
			cols: 6,
		},
		{
			label: 'Direccion',
			key: 'address',
			type: 'text',
			value: contact.address || '',
			cols: 6,
		},
		{
			label: 'Telefono',
			key: 'phone',
			type: 'text',
			value: contact.phone || '',
			cols: 6,
		},
		{
			label: 'Cuenta de Contacto',
			key: 'account',
			type: 'text',
			value: contact.account ? (contact.account.name || contact.account) : 'No tiene Cuenta vinculada',
			link: contact.account ? `/AdminScreen/accounts/account/${contact.account._id || contact.account}` : null,
			cols: 6,
		},
		{
			label: 'Carpeta',
			key: 'folder',
			type: 'text',
			value: contact.folder || '',
			cols: 6,
		},
		{
			label: 'Observaciones',
			key: 'observations',
			type: 'textarea',
			value: contact.observations || '',
			rows: 10,
			cols: 12,
		},
	];

	const title = (
		<OverlayTrigger
			right='left'
			overlay={
				<Popover id='tooltip-contact-info' style={{ minWidth: '50%' }}>
					<Popover.Header as='h3'>Información del Contacto</Popover.Header>
					<Popover.Body>
						<p>
							La información que aquí se visualiza corresponde a los datos del contacto.
						</p>
					</Popover.Body>
				</Popover>
			}
		>
			<h2 className='text-center m-3' style={{ cursor: 'pointer' }}>
				<span>
					<MdInfoOutline />
				</span>
				Información del Contacto
			</h2>
		</OverlayTrigger>
	);

	return <DetailsViewer data={contactFields} headerContent={title} />;
}

export default ContactInfo;
